import { initializeApp, getApps, FirebaseApp } from "firebase/app"

export const firebaseConfig = {
    apiKey: "AIzaSyAlPjO5rewGypNPq_2nF8zmf4yxt4GsaiE",
    authDomain: "myagkij-kinoteatr.firebaseapp.com",
    databaseURL: "https://myagkij-kinoteatr.firebaseio.com",
    projectId: "myagkij-kinoteatr",
    storageBucket: "myagkij-kinoteatr.firebasestorage.app",
    messagingSenderId: "244389288847",
    appId: "1:244389288847:web:7f2246e21ddea941e609fa",
    measurementId: "G-XYBPB2T83J",
} as const

export function getFirebaseApp(): FirebaseApp {
    const existing = getApps()[0]
    return existing ?? initializeApp(firebaseConfig)
}

